import { IMedicalData, EmrPatVitals, Sys_Days, ISchedulingObj } from "./medical-recored.interfaces";
import { getDateObj, getNgBsObj } from "../shared";
import { isObject } from "util";
import { ITimeSlotObj } from "../blocks/timeSlotPicker/timeSlotPicker.service";

export function GeneralPrivilageCheck(privilegeParms: IDocPrivilages, patientParms: IVisitData, type: number) {
    let currentUser = sessionStorage.getItem('currentUser') ? JSON.parse(sessionStorage.getItem('currentUser')) : {};
    if (privilegeParms.patientFilePrivilege == 1) {
        return true;
    } else {
        if ((privilegeParms.allowDocEditOutPatFile == 1
            && privilegeParms.patientFileEditPeriod >= checkDocEditPeriod(patientParms))
            || patientParms.docId == currentUser.empID) {
            if (type == 2 || type == 4) {
                return true;
            } else {
                return false;
            }
        } else if ((privilegeParms.allowDocEditInPatFile == 1
            && privilegeParms.patientFileEditPeriod >= checkDocEditPeriod(patientParms))
            || patientParms.docId == currentUser.empID) {
            if (type == 1) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
}

export function checkDocEditPeriod(params: IVisitData): number {
    if (params) {
        let date1 = new Date();
        let date2 = new Date(params.visitDate);
        return Math.abs(date1.getTime() - date2.getTime()) / 36e5;
    }
}

export interface IDocPrivilages {
    patientFilePrivilege?: number;    //  logged in doctor can change data if this variable = 1
    allowDocEditOutPatFile?: number;  // any doctor can change data if this variable = 1 else show data only.
    allowDocEditInPatFile?: number;  // any doctor can change data if this variable = 1 else show data only.
    patientFileEditPeriod?: number; // period for change data
}

export interface IVisitData {
    serial: number;
    visitSerial: number;
    docId: number;
    contractId: number;
    visitNo: number;
    visitDate: any;
    patCode: number;
    placeCode: number;
    resourceType: number;
    resourceId: number;
    regPatServiceSerial: number;
    pharmacy: number;
    specialityId?: number;
    type: number;
    filterByVisitsList?: number;
    visitsList?: string;
    episoidVisits?: string;
    nphiesSpecialtyID?:string
    filterByEpisoidVisits?: number;
    editableContent?: boolean;
    age: number;
    chronic?: number;
    patientGender?: number
    isPregnancy?: number;

}


export function clearHTMLTags(str: string) {
    return str.replace(/(<([^>]+)>)/ig, "");
}

export function convertHtmlEntities(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

export function convertTextHTML(input_str: string): any {
    // var input_str; //store input
    var text_input; //store input after beging trim()med
    var output_html = ""; //store output
    var counter;
    if (input_str == null || input_str == undefined)
        input_str = "";


    text_input = input_str.trim(); //trim() input
    if (text_input.length > 0) {
        output_html += ""; //begin by creating paragraph
        for (counter = 0; counter < text_input.length; counter++) {
            switch (text_input[counter]) {
                case '\n':
                    if (text_input[counter + 1] === '\n') {
                        output_html += "\n";
                        counter++;
                    }
                    else output_html += "<br>";
                    break;

                case ' ':
                    if (text_input[counter - 1] != ' ' && text_input[counter - 1] != '\t')
                        output_html += " ";
                    break;

                case '\t':
                    if (text_input[counter - 1] != '\t')
                        output_html += " ";
                    break;

                case '&':
                    output_html += "&amp;";
                    break;

                case '"':
                    output_html += "&quot;";
                    break;

                case '>':
                    output_html += "&gt;";
                    break;

                case '<':
                    output_html += "&lt;";
                    break;

                default:
                    output_html += text_input[counter];

            }

        }
        output_html += ""; //finally close paragraph
    }
    return output_html; // display output html
}


export function readTextFile(file) {
    var rawFile = new XMLHttpRequest();
    var fileData = '';
    rawFile.open("GET", file + "?v="+ + new Date(), false);
    rawFile.onreadystatechange = () => {
        if (rawFile.readyState === 4) {
            if (rawFile.status === 200 || rawFile.status == 0) {
                fileData = rawFile.responseText;
            }
        }
    }
    rawFile.send(null);
    return fileData;
}

export function encodeStr(str: string): string {
    return window.btoa(str);
}

export function decodeStr(str: string): string {
    return window.atob(str);
}

////////////// time slot methods

//Parse In
const parseIn = (date_time) => {
    var d = new Date();
    d.setHours(date_time.substring(11, 13));
    d.setMinutes(date_time.substring(14, 16));

    return d;
}

//make list
const getTimeIntervals = (time1, time2, timeSlot) => {
    var arr = [];
    while (time1 < time2) {
        arr.push(time1.toTimeString().substring(0, 5));
        time1.setMinutes(time1.getMinutes() + timeSlot);
    }

    return arr;
}

export function createTimeSlots(startTime, endTime, timeSlot): any[] {
    startTime = parseIn(startTime);
    endTime = parseIn(endTime);
    var intervals = getTimeIntervals(startTime, endTime, timeSlot);
    return intervals;
}

/**
 * General Method: return date in format of dd-MM-yyyy
 * @param date
 */
export const formatDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

/**
 * General Meth : Remove Duplicated Objects From Array of Objects based on Specific Property...
 * @param targetArr
 * @param prop
 */
export function removeDuplicates(targetArr, prop) {
    return targetArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
}

export function groupArrayByKey(arr, key) {
    return arr.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

// get week days part

/**
 * General Method: take start date as parameter and return array of 7 day dates start with given date
 * @param start : Date Parameter
 */
export function getWeekDates(start?: Date, end?: Date) {
    var days = [
        { id: 2, name: 'Sunday', sysNo: 0 },
        { id: 3, name: 'Monday', sysNo: 1 },
        { id: 4, name: 'Tuesday', sysNo: 2 },
        { id: 5, name: 'Wednesday', sysNo: 3 },
        { id: 6, name: 'Thursday', sysNo: 4 },
        { id: 7, name: 'Friday', sysNo: 5 },
        { id: 1, name: 'Saturday', sysNo: 6 }
    ];

    // var dt = start ? start : new Date()  //current date of week
    // var currentWeekDay = dt.getDay();
    // var lessDays = currentWeekDay == 0 ? 6 : currentWeekDay - 1;
    var wkStart = start ? start : new Date(); //new Date(new Date(dt).setDate(dt.getDate() - lessDays));
    var wkEnd = end ? end : new Date(new Date(wkStart).setDate(wkStart.getDate() + 6));


    let daylist = getDaysArray(new Date(formatDate(wkStart.toUTCString())), new Date(formatDate(wkEnd.toUTCString())));
    daylist.map((v) => v.toISOString().slice(0, 10)).join(",").split(',');
    let datesRange = [];
    for (let day = 0; day < daylist.length; day++) {
        const _date = daylist[day];
        let d = new Date(_date);
        let dayObj = days.find((el) => d.getDay() === el.sysNo);
        let dayId = dayObj ? dayObj.id : null;
        let sysDay = dayObj ? dayObj.sysNo : null;
        datesRange.push({ dayNo: dayId, _date: formatDate(d.toUTCString()), sysNo: sysDay });
    }

    return datesRange;
}

/**
 * General Method: return array with 7 days between two dates
 * @param start
 * @param end
 */
export const getDaysArray = (start, end) => {
    for (var arr = [], dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
        arr.push(new Date(dt));
    }
    return arr;
};

/**
 * General Method Give you Object contains ar and en name of day by insert selected date.
 * @param _date date you wanna to know name
 */
export const GetDayObjByDate = (_date: Date) => {
    let days = [
        { nameAr: 'الأحد', nameEn: 'Sunday', sysNo: 0 },
        { nameAr: 'الإثنين', nameEn: 'Monday', sysNo: 1 },
        { nameAr: 'الثلاثاء', nameEn: 'Tuesday', sysNo: 2 },
        { nameAr: 'الأربعاء', nameEn: 'Wednesday', sysNo: 3 },
        { nameAr: 'الخميس', nameEn: 'Thursday', sysNo: 4 },
        { nameAr: 'الجمعة', nameEn: 'Friday', sysNo: 5 },
        { nameAr: 'السبت', nameEn: 'Saturday', sysNo: 6 }
    ];

    let d = new Date(_date);
    let dayObj = days.find((el) => d.getDay() === el.sysNo);
    return dayObj;
}

/**
 * General Method return last Day of week that start with a given start day.
 * @param start
 */
export const getWeekEnd = (start?: Date, period?: number) => {
    let wkStart = start ? start : new Date();  //current date of week
    let wkEnd = new Date(new Date(wkStart).setDate(wkStart.getDate() + (period ? period : 6)));
    return wkEnd;
}

export const getWeekStart = (end?: Date, period?: number) => {
    let wkEnd = end ? end : new Date();  //current date of week
    let wkStart = new Date(new Date(wkEnd).setDate(wkEnd.getDate() - (period ? period : 6)));
    return wkStart;
}

/**
 * Check if doctor time disabled or not. and return new array with disabled times for doctor.
 * @param docTimeRange
 * @param timesArr
 */
export const checkDoctorTimeDisabled = (docTimeRange: any, timesArr: string[]): string[] => {
    let disabledTimes: any[] = [];
    docTimeRange.startTime = (docTimeRange.startTime as string).replace(':' + (docTimeRange.startTime as string).split(':')[2], ':00')
    docTimeRange.endTime = (docTimeRange.endTime as string).replace(':' + (docTimeRange.endTime as string).split(':')[2], ':00')
    let start = new Date(formatDate(new Date()) + ' ' + docTimeRange.startTime);
    let end = new Date(formatDate(new Date()) + ' ' + docTimeRange.endTime);
    timesArr.forEach(time => {
        let _date = new Date(formatDate(new Date()) + ' ' + time);
        if (_date >= start && _date <= end) {
            return false;
        } else {
            disabledTimes.push(time);
        }
    });
    return disabledTimes;
}


/**
 * Genereal Method: check if tab is madatory or not.
 * return {ar: string, en: string}[] contains tabs mandatory if tab data length = 0
 * @param emrData
 */
export function checkMedicalMandatoryBlocks(emrData: IMedicalData, VitalsData?: EmrPatVitals[]): { ar: string, en: string }[] {
    let mandatoryStrs: { ar: string, en: string }[] = []
    if (emrData.EmrTabs && emrData.EmrTabs.length > 0) {
        emrData.EmrTabs.forEach(tab => {

            if (tab.mandatory && tab.tapCode.toLowerCase() == 'Diagnois'.toLowerCase()) {
                if (!emrData.Diagnois || emrData.Diagnois.length == 0) {
                    mandatoryStrs.push({ ar: tab.tapNameAr, en: tab.tapNameEn });
                }
            }
            if (tab.mandatory && tab.tapCode.toLowerCase() == 'Complains'.toLowerCase()) {
                if (!emrData.Complain || emrData.Complain.length == 0) {
                    mandatoryStrs.push({ ar: tab.tapNameAr, en: tab.tapNameEn });
                }
            }

            if (tab.mandatory && tab.tapCode.toLowerCase() == 'Vitals'.toLowerCase()) {
                if (!VitalsData || VitalsData.length == 0) {
                    mandatoryStrs.push({ ar: tab.tapNameAr, en: tab.tapNameEn });
                }
            }
        });
    }
    return mandatoryStrs;
}


/**
 * generate string time format as: hh:mm:ss
 * @param date
 */
export function formatDateAsTime(date) {
    var today = new Date(date);
    var h = today.getHours();
    var m = today.getMinutes();
    var s = today.getSeconds();
    // add a zero in front of numbers<10
    m = checkTime(m);
    s = checkTime(s);
    let time = h + ":" + m + ":" + s;
}

const checkTime = (i) => {
    if (i < 10) {
        i = "0" + i;
    }
    return i;
}


/**
 * clean object from null or undefined properties
 * @param obj
 */
export function cleanObject(obj) {
    var propNames = Object.getOwnPropertyNames(obj);
    for (var i = 0; i < propNames.length; i++) {
        var propName = propNames[i];
        if (obj[propName] === null || obj[propName] === undefined || obj[propName] == "") {
            delete obj[propName];
        }
    }
}


export function getUniqueObjectValues(obj, newValue) {
    var propNames = Object.getOwnPropertyNames(obj);
    for (var i = 0; i < propNames.length; i++) {
        var propName = propNames[i];
        if (obj[propName].includes(newValue)) {
            delete obj[propName];
        }
    }
    return obj;
}


export const mergeByProperty = (target, source, prop) => {
    source.forEach(sourceElement => {
        let targetElement = target.find(targetElement => {
            return sourceElement[prop] === targetElement[prop];
        })
        targetElement ? Object.assign(targetElement, sourceElement) : target.push(sourceElement);
    })
}


/**
 * Filter All Patient By Group in Sidebar
 * @param data
 * @param prop
 * @param originalList
 */
export function filterByGroup(data: string, prop: string, originalList: Array<any>) {
    data = String(data);
    let filteredList: any[];
    if (data && originalList) {
        data = data.toLowerCase();
        let filtered = originalList.filter(item => {
            let match = false;
            if (item[prop].toString() == data) {
                match = true;
            }
            return match;
        });
        filteredList = filtered;
    }
    else {
        filteredList = originalList;
    }
    return filteredList;
}

/**
 * Prepare Array of data to save with any type of medical scores
 * @param medicalScores
 * @param type
 */
export function PrepareMedicalScoresToSave<T>(medicalScores: T[], visitSerial: number) {
    let temp = [];
    let keysData: string[] = [];
    if (medicalScores && medicalScores.length > 0) keysData = Object.getOwnPropertyNames(medicalScores[0]);
    for (let i = 0; i < medicalScores.length; i++) {
        const element = medicalScores[i];
        let scoreObj: T = <T>{};
        keysData.forEach(key => {
            if (key == 'serial')
                scoreObj[key] = element[key] > 0 ? element[key] : (i + 1) * -1;
            else if (key == 'visitSerial')
                scoreObj[key] = visitSerial;
            else
                scoreObj[key] = element[key];
        });
        if (scoreObj['serial'] <= 0 && scoreObj['result'])
            temp.push(scoreObj);
    }
    return temp;
}


export function changeNamesInPatientArray(arr: any[]) {
    if (arr && arr.length > 0) {
        arr.map(el => {
            if (el.fullnameAr && el.fullnameAr.length > 19) {
                el.fullnameAr = el.fullnameAr.substr(0, 19);
            }
            if (!el.fullnameAr || el.fullnameAr.length == 0) el.fullnameAr = 'لا يوجد اسم';
            if (el.fullnameEn && el.fullnameEn.length > 19) {
                el.fullnameEn = el.fullnameEn.substr(0, 19);
            }
            if (!el.fullnameEn || el.fullnameEn.length == 0) el.fullnameEn = 'No Name Found';
            return el;
        });
    }
    return arr;
}

//#region scheduling description generator

/**
 * Generate Scheduling Description of Schedule Type No. #3
 * @param Object Contains { freqQty, periodQty, freqType, periodType }
 */
export function GeneratePromotionDesc({ freqQty, periodQty, freqType, periodType }): { ar: string, en: string } {
    let s = freqQty;

    freqQty = freqQty > 0 ? freqQty : 0;
    let freqName: { ar?: string, en?: string } = { ar: '', en: '' };
    let freqNames: { ar?: string, en?: string } = { ar: '', en: '' };

    if (freqType == 3) {
        freqName = { ar: 'يوم', en: 'Day' };
        freqNames = { ar: 'أيام', en: 'Days' };
    }
    if (freqType == 4) {
        freqName = { ar: 'اسبوع', en: 'Week' };
        freqNames = { ar: 'أسابيع', en: 'Weeks' };
    }
    if (freqType == 5) {
        freqName = { ar: 'شهر', en: 'Month' };
        freqNames = { ar: 'شهور', en: 'Months' };
    }

    periodQty = periodQty > 0 ? periodQty : 0;
    let periodName: { ar?: string, en?: string } = { ar: '', en: '' };
    let periodNames: { ar?: string, en?: string } = { ar: '', en: '' };

    if (periodType == 3) {
        periodName = { ar: 'يوم', en: 'Day' };
        periodNames = { ar: 'أيام', en: 'Days' };
    }
    if (periodType == 4) {
        periodName = { ar: 'اسبوع', en: 'Week' };
        periodNames = { ar: 'أسابيع', en: 'Weeks' };
    }
    if (periodType == 5) {
        periodName = { ar: 'شهر', en: 'Month' };
        periodNames = { ar: 'شهور', en: 'Months' };
    }
    if (s == 1 || s == 2)
        return {
            ar: freqType > 2 ?
                ` كل   ${freqQty} ${freqName.ar} ${periodQty ? 'لمدة ' + periodQty + ' ' + periodName.ar : ''}` :
                ` كل ${s} ساعة ${periodQty ? 'لمدة ' + periodQty + ' ' + periodName.ar : ''} `,

            en: freqType > 2 ?
                ` Every ${freqQty} ${freqName.en} ${periodQty ? 'For ' + periodQty + ' ' + periodName.en : ''}` :
                ` Every ${s} Hour ${periodQty ? 'For ' + periodQty + ' ' + periodName.en : ''}`
        };
    else if (s > 2)
        return {
            ar: freqType > 2 ?
                ` كل ${freqQty} ${freqNames.ar} ${periodQty ? 'لمدة ' + periodQty + ' ' + periodName.ar : ''}` :
                ` كل ${s} ساعات ${periodQty ? 'لمدة ' + periodQty + ' ' + periodName.ar : ''}`,
            en: freqType > 2 ?
                ` Every ${freqQty} ${freqNames.en} ${periodQty ? 'For ' + periodQty + ' ' + periodName.en : ''}` :
                ` Every ${s} Hours ${periodQty ? 'For ' + periodQty + ' ' + periodName.en : ''}`
        };
    else
        return {
            ar: '',
            en: ''
        }
}

/**
 * Generate Scheduling Description of Schedule Type No. #2
 * @param scheduleObj
 */
export const GetScheduleDescType2 = (freqQty: number, periodQty: number): { ar: string, en: string } => {
    if (freqQty && periodQty) {
        return {
            ar: `${freqQty} ${freqQty > 2 ? 'مرات' : 'مرة'} كل اسبوع لمدة ${periodQty} ${periodQty > 2 && periodQty <= 10 ? 'اسابيع' : 'اسبوع'}`,
            en: `${freqQty} ${freqQty > 2 ? 'times' : 'time'} every week for ${periodQty} ${periodQty > 2 && periodQty <= 10 ? 'weeks' : 'week'}`
        }
    } else {
        return {
            ar: '',
            en: ''
        }
    }
}

/**
 * Generate Scheduling Description of Schedule Type No. #1
 * @param scheduleObj
 */
export const GetScheduleDescType1 = (scheduleObj: ISchedulingObj): { ar: string, en: string } => {
    if (scheduleObj && isObject(scheduleObj)) {
        let periods = GeneratePeriodDesc(scheduleObj.periodType, scheduleObj.periodQty);
        if (scheduleObj.freqType == 2) {
            return {
                ar: `كل ${scheduleObj.freqQty} ${scheduleObj.freqQty > 2 && scheduleObj.freqQty <= 10 ? 'ساعات' : 'ساعه'} لمدة ${scheduleObj.periodQty} ${periods.ar}`,
                en: `Every ${scheduleObj.freqQty} ${scheduleObj.freqQty > 2 && scheduleObj.freqQty <= 10 ? 'hours' : 'hour'} For ${scheduleObj.periodQty} ${periods.en}`,
            }
        } else {
            let daysDesc = GenerateDaysDesc(scheduleObj.days);
            return {
                ar: `كل (${daysDesc.ar}) لمدة ${scheduleObj.periodQty} ${periods.ar}`,
                en: `Every (${daysDesc.en}) For ${scheduleObj.periodQty} ${periods.en}`
            }
        }
    }
    return
}

// helper function used to dynamically generate period description
function GeneratePeriodDesc(periodType: number, periodQty: number): { ar: string, en: string } {
    let periods: { ar: string, en: string };
    if (periodType == 3) {
        periods = {
            ar: `${periodQty > 2 && periodQty <= 10 ? 'أيام' : 'يوم'}`,
            en: `${periodQty > 2 && periodQty <= 10 ? 'days' : 'day'}`
        }
    } else if (periodType == 4) {
        periods = {
            ar: `${periodQty > 2 && periodQty <= 10 ? 'أسابيع' : 'أسبوع'}`,
            en: `${periodQty > 2 && periodQty <= 10 ? 'weeks' : 'week'}`
        }
    } else if (periodType == 5) {
        periods = {
            ar: `${periodQty > 2 && periodQty <= 10 ? 'شهور' : 'شهر'}`,
            en: `${periodQty > 2 && periodQty <= 10 ? 'months' : 'month'}`
        }
    } else {
        periods = { ar: '', en: '' }
    }
    return periods;
}

// helper function to generate days names dynamic
function GenerateDaysDesc(days: string): { ar: string, en: string } {
    let sysDays = Sys_Days;
    if (days && days.length > 0) {
        let daysNo: number[] = days.split(',').map(code => +code);
        let daysStr = sysDays.filter(day => daysNo.includes(day.code));
        let daysDesc = {
            ar: daysStr.map(day => day.nameAr).toString(),
            en: daysStr.map(day => day.nameEn).toString()
        }
        return daysDesc;
    }
    return { ar: '', en: '' }
}

//#endregion

/**
 * Prepare Mesage Template with original data of client and return msg as string
 * @param client
 */
export function PrepareMessageForClient(client: any): string {
    let message: string = client && client.message ? client.message : '';
    let regx = /'(.*?)'/g;
    if (message && message.length > 0) {
        let quotes = message.match(regx);
        if (quotes && quotes.length > 0) {
            quotes.forEach((quote: string) => {
                if (quote.toLowerCase().includes('patientname'))
                    message = message.replace(quote, client.fullnameAr + '');
                else if (quote.toLowerCase().includes('clinicname'))
                    message = message.replace(quote, client.clinicNameAr + '');
                else if (quote.toLowerCase().includes('reservationdate'))
                    message = message.replace(quote, client.reservationDate + '');
            });
        }
        return message;
    }
    return 'No Message';
}

/**
 * function to generate json string from Object
 * @param targetObj
 */
export function GenerateJsonFromObject<T>(targetObj: T): string {
    // let newArr: { tableName: string; postfix?: number; colName: string; colVal: any; colType: string; }[] = [];
    let newObj: T = <T>{};
    if (targetObj) {
        let keysData = Object.getOwnPropertyNames(targetObj);
        keysData.forEach(key => {
            if (targetObj[key]) {
                newObj[key] = targetObj[key];
                // newArr.push({ colName: key, colVal: targetObj[key], colType: typeof (targetObj[key]) });
            }
        });
        return JSON.stringify(newObj);
    }
    return '';
}

/**
 * function to generate Object from json string
 * @param targetStr
 */
export function GenerateObjectFromJson<T>(targetStr: string): T {
    let newObj: T = <T>{};
    if (targetStr) {
        // let newArr: { colName: string; colVal: any; colType: string; }[] = JSON.parse(targetStr);
        // if (newArr && newArr.length > 0) {
        //     newArr.forEach((column, indx) => {
        //         newObj[column.colName] = column.colVal;
        //         delete newObj[indx];
        //     });
        // }
        newObj = JSON.parse(targetStr);
    }
    return newObj;
}

/**
 * Object Dates Converter take obj and type of convert direction
 * @param editCriteria
 * @param type 'NGB' | 'OBJ'
 */
export function ObjectDatesConverter<T>(editCriteria: T, type: 'NGB' | 'OBJ') {
    let keysData = Object.getOwnPropertyNames(editCriteria);
    keysData.forEach(key => {
        if ((key.endsWith('DateFrom') || key.endsWith('DateTo')) && editCriteria[key])
            if (type == 'OBJ')
                editCriteria[key] = new Date(getDateObj(editCriteria[key])).toISOString();
            else if (type == 'NGB')
                editCriteria[key] = getNgBsObj(editCriteria[key]);
    });
    return editCriteria;
}


export function GetExpireDateOfPromotion(periodType: number, periodQty: number, startDate: Date) {
    let days: number = periodQty;
    if (periodType && periodQty && startDate) {
        if (periodType == 4) {
            days = periodQty * 7;
        } else if (periodType == 5) {
            days = periodQty * 30;
        } else {
            days = periodQty;
        }
        return getWeekEnd(startDate, days);
    }
}

/**
 * method to group array with key and return map
 * ex: const groupedData = groupBy(your-array-of-objects, obj => obj.your-key);
 * to get data of key =>>>> ex: groupedData.get('object-key-value');
 * @param list
 * @param keyGetter callback function - ex: () => {}
 */
export const groupBy = (list, keyGetter) => {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}


export function GenerateRangeTimeSlot(timeSlot: ITimeSlotObj, period: number, type: number): ITimeSlotObj {
    if (timeSlot && period && type) {
        let slots: number = 0;
        if (type == 1) { } // year
        else if (type == 2) { } // month
        else if (type == 3) { } // week
        else if (type == 4) { } // day
        else if (type == 5) { } // hour
        else if (type == 6) { // minute
            slots = +(period / timeSlot.minutesPerSlot).toFixed();
            timeSlot.endTimeSlot = new Date(new Date(timeSlot.startTimeSlot).setMinutes(period));
            let hr = timeSlot.endTimeSlot.getHours();
            let min = timeSlot.endTimeSlot.getMinutes();
            timeSlot.endTime = (hr > 9 ? hr : '0' + hr) + ':' + (min > 9 ? min : '0' + min);
            timeSlot.lastSlotId = timeSlot.id + (slots - 1);
        }
    }
    return timeSlot;
}


export function loadStylesDynamic(styleUrl: string, id: string) {
    const head = document.getElementsByTagName('head')[0];

    const link = document.getElementById(id) as HTMLLinkElement;
    if (link) {
        link.href = styleUrl;
    } else {
        const link = document.createElement('link');
        link.id = id;
        link.href = styleUrl;
        head.appendChild(link);
    }
}

// define a decorator (@publish) for marking members of a class for export:
export function publish(targetObj: object, memberKey: string, descriptor: PropertyDescriptor) {
    if (!targetObj['_publishedMembers'])
        targetObj['_publishedMembers'] = [];
    targetObj['_publishedMembers'].push(memberKey);
}

// this function can return the set of members of an object marked with the @publish decorator:
export function getPublishedMembers(fromObj: object) {
    const res = {};
    const members = fromObj['_publishedMembers'] || [];
    members.forEach(member => { res[member] = fromObj[member].bind(fromObj); });
    return res;
}

export function isnull(target, replace) {
    if (!target || target == null || isNaN(target)) return replace;
}

/**
 * Method Convert File to Base64 encryption and return promise with encrypted value
 * @param file
 */
export function fileToBase64(file: File): Promise<any> {
    return new Promise(resolve => {
        var reader = new FileReader();
        // Read file content on file loaded event
        reader.onload = function (event: any) {
            resolve(event.target.result);
        };

        // Convert data to base64
        reader.readAsDataURL(file);
    });
};


export function GetDateFromTimeObj(time: any) {
    let _date = new Date().setHours(time.hour, time.minute)
    return new Date(_date);
}
